import { makeVar } from '@apollo/client'

export interface StudioPage {
    activeStudioHeaderTab: string
}

const studioPageInitial = {
    activeStudioHeaderTab: 'element-library',
}

export const studioPage = makeVar<StudioPage>({
    ...studioPageInitial,
})

export const setActiveStudioHeaderTab = (value: string) => {
    studioPage({ activeStudioHeaderTab: value })
}
